import { formatReportRatio } from '../helpers/reportRatio'
import React from 'react'
import AltRouteOutlined from '@mui/icons-material/AltRouteOutlined'
import LocationOnOutlined from '@mui/icons-material/LocationOnOutlined'
import TrendingUpOutlined from '@mui/icons-material/TrendingUpOutlined'
import GoogleIcon from '../../../icon/GoogleIcon'
import { formatMoney, safePercent } from '../../../helpers/utils'
import { formatLastActivity } from './reportMobileUserCardUtils'

const iconSize = { fontSize: 20 }

export function buildReportRefundsUserMobileCardSections(model) {
  const userName = model.user_name ?? '—'
  const visited = model.total_visited_in_route_clients ?? 0
  const attended = model.total_in_route_clients ?? 0
  const visitasStr = `${visited}/${attended}`
  const lastAct = formatLastActivity(model.last_visit)

  const summaryRows = [
    { label: 'Usuario', value: userName, valueTitle: userName },
    { label: 'Última actividad', value: lastAct, valueTitle: lastAct },
    { label: 'Visitas realizadas', value: visitasStr, valueTitle: visitasStr }
  ]

  const geo = formatReportRatio(model.geofence_activities_count, model.total_activities_count)

  const detailRows = [
    {
      icon: <AltRouteOutlined sx={iconSize} />,
      label: 'Visitas fuera de ruta',
      value: String(model.out_of_route_clients ?? 0),
      boldValue: true,
      valueTitle: String(model.out_of_route_clients ?? 0)
    },
    {
      icon: <TrendingUpOutlined sx={iconSize} />,
      label: 'Efectividad',
      value: `${safePercent(visited, attended)}%`,
      boldValue: true,
      valueTitle: `${safePercent(visited, attended)}%`
    },
    {
      icon: <LocationOnOutlined sx={iconSize} />,
      label: 'Actividades en geocerca',
      value: geo,
      boldValue: true,
      valueTitle: geo
    },
    {
      icon: <GoogleIcon name="keyboard_return" size={20} />,
      label: 'Total devoluciones',
      value: formatMoney(model.total_refund),
      boldValue: true,
      valueTitle: formatMoney(model.total_refund)
    }
  ]

  return { summaryRows, detailRows }
}
